import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SimpleBlockSchema } from '@almanac/contracts';
import { z } from 'zod';
import { renderSimpleBlock } from './simple-registry.js';
export const UnsupportedVisualizationPropsSchema = z
    .object({
    requested_type: z.string(),
    signature: z.string().optional(),
    reason: z.string(),
    fallback_block: SimpleBlockSchema,
})
    .strict();
/**
 * Renders an `unsupported_visualization_request` block — the agent asked
 * for a visualization we don't (yet) support. Shows why, plus the
 * `fallback_block` it supplied instead, through the shared primitive
 * registry (always a non-recursive `SimpleBlock`).
 */
export function UnsupportedVisualizationPrimitive({ requested_type, reason, fallback_block, overlay, }) {
    return (_jsxs("div", { className: "rounded-lg border border-dashed border-border p-4", children: [_jsxs("p", { className: "mb-2 flex items-center gap-1.5 text-xs font-medium text-muted-foreground", children: [_jsx("span", { "aria-hidden": true, children: "\u25C7" }), "Requested visualization not supported: ", _jsx("span", { className: "font-mono", children: requested_type })] }), _jsx("p", { className: "mb-3 text-xs text-muted-foreground/80", children: reason }), renderSimpleBlock(fallback_block, overlay)] }));
}
